import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/functions";
import "firebase/database";
import "firebase/analytics";
import "firebase/auth";
import "firebase/storage";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyBrpP2svwcJAscyuggAyjK318G7J-x7wvI",
  authDomain: "chup-chaap-af322.firebaseapp.com",
  databaseURL: "https://chup-chaap-af322.firebaseio.com",
  projectId: "chup-chaap-af322",
  storageBucket: "chup-chaap-af322.appspot.com",
  messagingSenderId: "603122944980",
  appId: "1:603122944980:web:cf18ba594393d3ae5f2441",
  measurementId: "G-LE24TZ2JGQ"
};
firebase.initializeApp(config);

const analytics = firebase.analytics();
const functions = firebase.functions();
const db = firebase.database();
const auth = firebase.auth();
const firestore = firebase.firestore();
const storage = firebase.storage();

export { analytics, auth, db, firestore, functions, storage };
